export { default } from './share'
